import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieTesterService {
  checkCookies(): boolean {
    document.cookie = 'rv-test-local-cookie=yes';
    if (document.cookie.indexOf('rv-test-local-cookie') > -1) {
      return true;
    }

    return false;
  }
}
